import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import { Flex, Spinner } from "@chakra-ui/react";

export default function ProtectedRoutes({
  allowedRoles,
}: {
  allowedRoles: string[];
}) {
  const { role, loading } = useAuth();
  const location = useLocation();

  // Show loading until Firebase auth is ready
  if (loading && !role)
    return (
      <Flex
        flexDir="column"
        w="full"
        h="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner />
      </Flex>
    );

  return role && allowedRoles.includes(role) ? (
    <Outlet />
  ) : (
    <Navigate
      to="/login"
      replace
      state={{
        from: `${location.pathname}${location.search}${location.hash}`,
      }}
    />
  );
}
